export const staff = (state) => {
    return state.staff
}

export const partakers = (state) => {
    return state.partakers
}
export const staffs = (state) => {
    return state.staffs
}
export const payouts = (state) => {
    return state.payouts
}
export const isViewMobile = (state) => {
    return state.isViewMobile
}
export const coupons = (state) => {
    return state.coupons
}